
export class GridReferences {
    /*****************************************************************************
    *
    * GT_OSGB holds OSGB grid coordinates **
    *
    *****************************************************************************/
    //Object.defineProperty(exports, "__esModule", { value: true });
    static OSGB = /** @class */ (function () {
        function OSGB() {
            var _this = this;
            this.initialised = false;
            this.northings = 0;
            this.eastings = 0;
            this.status = "Undefined";
            this.init = function () {
                if (!_this.initialised) {
                    _this.prefixes = new Array(new Array("SV", "SW", "SX", "SY", "SZ", "TV", "TW"), new Array("SQ", "SR", "SS", "ST", "SU", "TQ", "TR"), new Array("SL", "SM", "SN", "SO", "SP", "TL", "TM"), new Array("SF", "SG", "SH", "SJ", "SK", "TF", "TG"), new Array("SA", "SB", "SC", "SD", "SE", "TA", "TB"), new Array("NV", "NW", "NX", "NY", "NZ", "OV", "OW"), new Array("NQ", "NR", "NS", "NT", "NU", "OQ", "OR"), new Array("NL", "NM", "NN", "NO", "NP", "OL", "OM"), new Array("NF", "NG", "NH", "NJ", "NK", "OF", "OG"), new Array("NA", "NB", "NC", "ND", "NE", "OA", "OB"), new Array("HV", "HW", "HX", "HY", "HZ", "JV", "JW"), new Array("HQ", "HR", "HS", "HT", "HU", "JQ", "JR"), new Array("HL", "HM", "HN", "HO", "HP", "JL", "JM"));
                    _this.initialised = true;
                }
            };
            this.SetError = function (msg) {
                _this.status = msg;
            };
            this.SetGridCoordinates = function (eastings, northings) {
                _this.northings = northings;
                _this.eastings = eastings;
                _this.status = "OK";
            };
            this.LogGridRef = function () {
                var gr = _this.GetGridRef(4);
                console.log(gr);
            };
            this.GetGridRef = function (precision) {
                if (precision < 0) {
                    precision = 0;
                }
                if (precision > 5) {
                    precision = 5;
                }
                var e;
                var n;
                var y = 0;
                var x = 0;
                if (precision > 0) {
                    y = Math.floor(_this.northings / 100000);
                    x = Math.floor(_this.eastings / 100000);
                    e = Math.round(_this.eastings % 100000);
                    n = Math.round(_this.northings % 100000);
                    var div = (5 - precision);
                    /* CHANGED to round DOWN, not up
                    gives more precise co-ords close to gridlines*/
                    e = Math.floor(e / Math.pow(10, div));
                    n = Math.floor(n / Math.pow(10, div));
                    //e=Math.round(e / Math.pow(10, div));
                    //n=Math.round(n / Math.pow(10, div));
                }
                var prefix = _this.prefixes[y][x];
                return prefix + " " + _this._zeropad(e, precision) + " " + _this._zeropad(n, precision);
            };
            this.ParseGridRef = function (landranger) {
                var ok = false;
                var precision;
                _this.northings = 0;
                _this.eastings = 0;
                for (precision = 5; precision >= 1; precision--) {
                    var pattern = new RegExp("^([A-Z]{2})\\s*(\\d{" + precision + "})\\s*(\\d{" + precision + "})$", "i");
                    var gridRef = landranger.match(pattern);
                    if (gridRef) {
                        var gridSheet = gridRef[1];
                        var gridEast = 0;
                        var gridNorth = 0;
                        //5x1 4x10 3x100 2x1000 1x10000
                        if (precision > 0) {
                            var mult = Math.pow(10, 5 - precision);
                            gridEast = parseInt(gridRef[2], 10) * mult;
                            gridNorth = parseInt(gridRef[3], 10) * mult;
                        }
                        var x = void 0, y = void 0;
                        search: for (y = 0; y < _this.prefixes.length; y++) {
                            for (x = 0; x < _this.prefixes[y].length; x++)
                                if (_this.prefixes[y][x] == gridSheet) {
                                    _this.eastings = (x * 100000) + gridEast;
                                    _this.northings = (y * 100000) + gridNorth;
                                    ok = true;
                                    break search;
                                }
                        }
                    }
                }
                return ok;
            };
            this.GetWGS84 = function () {
                var height = 0;
                var lat1 = GridReferences.GtMath.E_N_to_Lat(_this.eastings, _this.northings, 6377563.396, 6356256.910, 400000, -100000, 0.999601272, 49.00000, -2.00000);
                var lon1 = GridReferences.GtMath.E_N_to_Long(_this.eastings, _this.northings, 6377563.396, 6356256.910, 400000, -100000, 0.999601272, 49.00000, -2.00000);
                var x1 = GridReferences.GtMath.Lat_Long_H_to_X(lat1, lon1, height, 6377563.396, 6356256.910);
                var y1 = GridReferences.GtMath.Lat_Long_H_to_Y(lat1, lon1, height, 6377563.396, 6356256.910);
                var z1 = GridReferences.GtMath.Lat_H_to_Z(lat1, height, 6377563.396, 6356256.910);
                var x2 = GridReferences.GtMath.Helmert_X(x1, y1, z1, 446.448, 0.2470, 0.8421, -20.4894);
                var y2 = GridReferences.GtMath.Helmert_Y(x1, y1, z1, -125.157, 0.1502, 0.8421, -20.4894);
                var z2 = GridReferences.GtMath.Helmert_Z(x1, y1, z1, 542.060, 0.1502, 0.2470, -20.4894);
                var latitude = GridReferences.GtMath.XYZ_to_Lat(x2, y2, z2, 6378137.000, 6356752.313);
                var longitude = GridReferences.GtMath.XYZ_to_Long(x2, y2);
                var wgs84 = new GridReferences.WGS84(latitude, longitude);
                return wgs84;
            };
            this._zeropad = function (num, len) {
                var str = num.toString();
                while (str.length < len) {
                    str = '0' + str;
                }
                return str;
            };
            this.init();
        }
        Object.defineProperty(OSGB.prototype, "Northings", {
            get: function () {
                return this.northings;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(OSGB.prototype, "Eastings", {
            get: function () {
                return this.eastings;
            },
            enumerable: true,
            configurable: true
        });
        return OSGB;
    }());
    //exports.OSGB = OSGB;
    /*****************************************************************************
    *
    * GT_WGS84 holds WGS84 latitude and longitude
    *
    *****************************************************************************/
    static WGS84 = /** @class */ (function () {
        function WGS84(latitude, longitude) {
            var _this = this;
            this.latitude = 0;
            this.longitude = 0;
            this.ParseString = function (text) {
                var ok = false;
                var str = text;
                //N 51° 53.947 W 000° 10.018
                var pattern = /([ns])\s*(\d+)[°\s]+(\d+\.\d+)\s+([we])\s*(\d+)[°\s]+(\d+\.\d+)/i;
                var matches = str.match(pattern);
                if (matches) {
                    ok = true;
                    var latsign = (matches[1] == 's' || matches[1] == 'S') ? -1 : 1;
                    var longsign = (matches[4] == 'w' || matches[4] == 'W') ? -1 : 1;
                    var d1 = parseFloat(matches[2]);
                    var m1 = parseFloat(matches[3]);
                    var d2 = parseFloat(matches[5]);
                    var m2 = parseFloat(matches[6]);
                    this.latitude = latsign * (d1 + (m1 / 60.0));
                    this.longitude = longsign * (d2 + (m2 / 60.0));
                }
                return ok;
            };
            this.IsGreatBritain = function () {
                return _this.latitude > 49 &&
                    _this.latitude < 62 &&
                    _this.longitude > -9.5 &&
                    _this.longitude < 2.3;
            };
            this.IsIreland = function () {
                return _this.latitude > 51.2 &&
                    _this.latitude < 55.73 &&
                    _this.longitude > -12.2 &&
                    _this.longitude < -4.8;
            };
            this.GetOSGB = function () {
                var osgb = new GridReferences.OSGB();
                if (_this.IsGreatBritain()) {
                    var height = 0;
                    var x1 = GridReferences.GtMath.Lat_Long_H_to_X(_this.latitude, _this.longitude, height, 6378137.00, 6356752.313);
                    var y1 = GridReferences.GtMath.Lat_Long_H_to_Y(_this.latitude, _this.longitude, height, 6378137.00, 6356752.313);
                    var z1 = GridReferences.GtMath.Lat_H_to_Z(_this.latitude, height, 6378137.00, 6356752.313);
                    var x2 = GridReferences.GtMath.Helmert_X(x1, y1, z1, -446.448, -0.2470, -0.8421, 20.4894);
                    var y2 = GridReferences.GtMath.Helmert_Y(x1, y1, z1, 125.157, -0.1502, -0.8421, 20.4894);
                    var z2 = GridReferences.GtMath.Helmert_Z(x1, y1, z1, -542.060, -0.1502, -0.2470, 20.4894);
                    var latitude2 = GridReferences.GtMath.XYZ_to_Lat(x2, y2, z2, 6377563.396, 6356256.910);
                    var longitude2 = GridReferences.GtMath.XYZ_to_Long(x2, y2);
                    var e = GridReferences.GtMath.Lat_Long_to_East(latitude2, longitude2, 6377563.396, 6356256.910, 400000, 0.999601272, 49.00000, -2.00000);
                    var n = GridReferences.GtMath.Lat_Long_to_North(latitude2, longitude2, 6377563.396, 6356256.910, 400000, -100000, 0.999601272, 49.00000, -2.00000);
                    osgb.SetGridCoordinates(Math.round(e), Math.round(n));
                }
                else {
                    osgb.SetError("Coordinate not within Great Britain");
                }
                return osgb;
            };
            this.latitude = latitude;
            this.longitude = longitude;
        }
        Object.defineProperty(WGS84.prototype, "Latitude", {
            get: function () {
                return this.latitude;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WGS84.prototype, "Longitude", {
            get: function () {
                return this.longitude;
            },
            enumerable: true,
            configurable: true
        });
        return WGS84;
    }());
    //exports.WGS84 = WGS84;
    /*****************************************************************************
    *
    * GtMath is a collection of static methods doing all the nasty sums
    *
    *****************************************************************************/
    static GtMath = /** @class */ (function () {
        function GtMath() {
        }
        GtMath.E_N_to_Lat = function (East, North, a, b, e0, n0, f0, PHI0, LAM0) {
            //Un-project Transverse Mercator eastings and northings back to latitude.
            //Input: - _
            //eastings (East) and northings (North) in meters; _
            //ellipsoid axis dimensions (a & b) in meters; _
            //eastings (e0) and northings (n0) of false origin in meters; _
            //central meridian scale factor (f0) and _
            //latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
            //'REQUIRES THE "Marc" AND "InitialLat" FUNCTIONS
            //Convert angle measures to radians
            var Pi = 3.14159265358979;
            var RadPHI0 = PHI0 * (Pi / 180);
            var RadLAM0 = LAM0 * (Pi / 180);
            //Compute af0, bf0, e squared (e2), n and Et
            var af0 = a * f0;
            var bf0 = b * f0;
            var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
            var n = (af0 - bf0) / (af0 + bf0);
            var Et = East - e0;
            //Compute initial value for latitude (PHI) in radians
            var PHId = GtMath.InitialLat(North, n0, af0, RadPHI0, n, bf0);
            //Compute nu, rho and eta2 using value for PHId
            var nu = af0 / (Math.sqrt(1 - (e2 * (Math.pow(Math.sin(PHId), 2)))));
            var rho = (nu * (1 - e2)) / (1 - (e2 * Math.pow(Math.sin(PHId), 2)));
            var eta2 = (nu / rho) - 1;
            //Compute Latitude
            var VII = (Math.tan(PHId)) / (2 * rho * nu);
            var VIII = ((Math.tan(PHId)) / (24 * rho * Math.pow(nu, 3))) * (5 + (3 * (Math.pow(Math.tan(PHId), 2))) + eta2 - (9 * eta2 * (Math.pow(Math.tan(PHId), 2))));
            var IX = ((Math.tan(PHId)) / (720 * rho * Math.pow(nu, 5))) * (61 + (90 * ((Math.tan(PHId)) ^ 2)) + (45 * (Math.pow(Math.tan(PHId), 4))));
            var E_N_to_Lat = (180 / Pi) * (PHId - (Math.pow(Et, 2) * VII) + (Math.pow(Et, 4) * VIII) - ((Et ^ 6) * IX));
            return (E_N_to_Lat);
        };
        GtMath.E_N_to_Long = function (East, North, a, b, e0, n0, f0, PHI0, LAM0) {
            //Un-project Transverse Mercator eastings and northings back to longitude.
            //Input: - _
            //eastings (East) and northings (North) in meters; _
            //ellipsoid axis dimensions (a & b) in meters; _
            //eastings (e0) and northings (n0) of false origin in meters; _
            //central meridian scale factor (f0) and _
            //latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
            //REQUIRES THE "Marc" AND "InitialLat" FUNCTIONS
            //Convert angle measures to radians
            var Pi = 3.14159265358979;
            var RadPHI0 = PHI0 * (Pi / 180);
            var RadLAM0 = LAM0 * (Pi / 180);
            //Compute af0, bf0, e squared (e2), n and Et
            var af0 = a * f0;
            var bf0 = b * f0;
            var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
            var n = (af0 - bf0) / (af0 + bf0);
            var Et = East - e0;
            //Compute initial value for latitude (PHI) in radians
            var PHId = GtMath.InitialLat(North, n0, af0, RadPHI0, n, bf0);
            //Compute nu, rho and eta2 using value for PHId
            var nu = af0 / (Math.sqrt(1 - (e2 * (Math.pow(Math.sin(PHId), 2)))));
            var rho = (nu * (1 - e2)) / (1 - (e2 * Math.pow(Math.sin(PHId), 2)));
            var eta2 = (nu / rho) - 1;
            //Compute Longitude
            var X = (Math.pow(Math.cos(PHId), -1)) / nu;
            var XI = ((Math.pow(Math.cos(PHId), -1)) / (6 * Math.pow(nu, 3))) * ((nu / rho) + (2 * (Math.pow(Math.tan(PHId), 2))));
            var XII = ((Math.pow(Math.cos(PHId), -1)) / (120 * Math.pow(nu, 5))) * (5 + (28 * (Math.pow(Math.tan(PHId), 2))) + (24 * (Math.pow(Math.tan(PHId), 4))));
            var XIIA = ((Math.pow(Math.cos(PHId), -1)) / (5040 * Math.pow(nu, 7))) * (61 + (662 * (Math.pow(Math.tan(PHId), 2))) + (1320 * (Math.pow(Math.tan(PHId), 4))) + (720 * (Math.pow(Math.tan(PHId), 6))));
            var E_N_to_Long = (180 / Pi) * (RadLAM0 + (Et * X) - (Math.pow(Et, 3) * XI) + (Math.pow(Et, 5) * XII) - (Math.pow(Et, 7) * XIIA));
            return E_N_to_Long;
        };
        GtMath.InitialLat = function (North, n0, afo, PHI0, n, bfo) {
            //Compute initial value for Latitude (PHI) IN RADIANS.
            //Input: - _
            //northing of point (North) and northing of false origin (n0) in meters; _
            //semi major axis multiplied by central meridian scale factor (af0) in meters; _
            //latitude of false origin (PHI0) IN RADIANS; _
            //n (computed from a, b and f0) and _
            //ellipsoid semi major axis multiplied by central meridian scale factor (bf0) in meters.
            //REQUIRES THE "Marc" FUNCTION
            //THIS FUNCTION IS CALLED BY THE "E_N_to_Lat", "E_N_to_Long" and "E_N_to_C" FUNCTIONS
            //THIS FUNCTION IS ALSO USED ON IT'S OWN IN THE  "Projection and Transformation Calculations.xls" SPREADSHEET
            //First PHI value (PHI1)
            var PHI1 = ((North - n0) / afo) + PHI0;
            //Calculate M
            var M = GtMath.Marc(bfo, n, PHI0, PHI1);
            //Calculate new PHI value (PHI2)
            var PHI2 = ((North - n0 - M) / afo) + PHI1;
            //Iterate to get final value for InitialLat
            while (Math.abs(North - n0 - M) > 0.00001) {
                PHI2 = ((North - n0 - M) / afo) + PHI1;
                M = GtMath.Marc(bfo, n, PHI0, PHI2);
                PHI1 = PHI2;
            }
            return PHI2;
        };
        GtMath.Lat_Long_H_to_X = function (PHI, LAM, H, a, b) {
            // Convert geodetic coords lat (PHI), long (LAM) and height (H) to cartesian X coordinate.
            // Input: - _
            //    Latitude (PHI)& Longitude (LAM) both in decimal degrees; _
            //  Ellipsoidal height (H) and ellipsoid axis dimensions (a & b) all in meters.
            // Convert angle measures to radians
            var Pi = 3.14159265358979;
            var RadPHI = PHI * (Pi / 180);
            var RadLAM = LAM * (Pi / 180);
            // Compute eccentricity squared and nu
            var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
            var V = a / (Math.sqrt(1 - (e2 * (Math.pow(Math.sin(RadPHI), 2)))));
            // Compute X
            return (V + H) * (Math.cos(RadPHI)) * (Math.cos(RadLAM));
        };
        GtMath.Lat_Long_H_to_Y = function (PHI, LAM, H, a, b) {
            // Convert geodetic coords lat (PHI), long (LAM) and height (H) to cartesian Y coordinate.
            // Input: - _
            // Latitude (PHI)& Longitude (LAM) both in decimal degrees; _
            // Ellipsoidal height (H) and ellipsoid axis dimensions (a & b) all in meters.
            // Convert angle measures to radians
            var Pi = 3.14159265358979;
            var RadPHI = PHI * (Pi / 180);
            var RadLAM = LAM * (Pi / 180);
            // Compute eccentricity squared and nu
            var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
            var V = a / (Math.sqrt(1 - (e2 * (Math.pow(Math.sin(RadPHI), 2)))));
            // Compute Y
            return (V + H) * (Math.cos(RadPHI)) * (Math.sin(RadLAM));
        };
        GtMath.Lat_H_to_Z = function (PHI, H, a, b) {
            // Convert geodetic coord components latitude (PHI) and height (H) to cartesian Z coordinate.
            // Input: - _
            //    Latitude (PHI) decimal degrees; _
            // Ellipsoidal height (H) and ellipsoid axis dimensions (a & b) all in meters.
            // Convert angle measures to radians
            var Pi = 3.14159265358979;
            var RadPHI = PHI * (Pi / 180);
            // Compute eccentricity squared and nu
            var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
            var V = a / (Math.sqrt(1 - (e2 * (Math.pow(Math.sin(RadPHI), 2)))));
            // Compute X
            return ((V * (1 - e2)) + H) * (Math.sin(RadPHI));
        };
        GtMath.Helmert_X = function (X, Y, Z, DX, Y_Rot, Z_Rot, s) {
            // (X, Y, Z, DX, Y_Rot, Z_Rot, s)
            // Computed Helmert transformed X coordinate.
            // Input: - _
            //    cartesian XYZ coords (X,Y,Z), X translation (DX) all in meters ; _
            // Y and Z rotations in seconds of arc (Y_Rot, Z_Rot) and scale in ppm (s).
            // Convert rotations to radians and ppm scale to a factor
            var Pi = 3.14159265358979;
            var sfactor = s * 0.000001;
            var RadY_Rot = (Y_Rot / 3600) * (Pi / 180);
            var RadZ_Rot = (Z_Rot / 3600) * (Pi / 180);
            //Compute transformed X coord
            return (X + (X * sfactor) - (Y * RadZ_Rot) + (Z * RadY_Rot) + DX);
        };
        GtMath.Helmert_Y = function (X, Y, Z, DY, X_Rot, Z_Rot, s) {
            // (X, Y, Z, DY, X_Rot, Z_Rot, s)
            // Computed Helmert transformed Y coordinate.
            // Input: - _
            //    cartesian XYZ coords (X,Y,Z), Y translation (DY) all in meters ; _
            //  X and Z rotations in seconds of arc (X_Rot, Z_Rot) and scale in ppm (s).
            // Convert rotations to radians and ppm scale to a factor
            var Pi = 3.14159265358979;
            var sfactor = s * 0.000001;
            var RadX_Rot = (X_Rot / 3600) * (Pi / 180);
            var RadZ_Rot = (Z_Rot / 3600) * (Pi / 180);
            // Compute transformed Y coord
            return (X * RadZ_Rot) + Y + (Y * sfactor) - (Z * RadX_Rot) + DY;
        };
        GtMath.Helmert_Z = function (X, Y, Z, DZ, X_Rot, Y_Rot, s) {
            // (X, Y, Z, DZ, X_Rot, Y_Rot, s)
            // Computed Helmert transformed Z coordinate.
            // Input: - _
            //    cartesian XYZ coords (X,Y,Z), Z translation (DZ) all in meters ; _
            // X and Y rotations in seconds of arc (X_Rot, Y_Rot) and scale in ppm (s).
            //
            // Convert rotations to radians and ppm scale to a factor
            var Pi = 3.14159265358979;
            var sfactor = s * 0.000001;
            var RadX_Rot = (X_Rot / 3600) * (Pi / 180);
            var RadY_Rot = (Y_Rot / 3600) * (Pi / 180);
            // Compute transformed Z coord
            return (-1 * X * RadY_Rot) + (Y * RadX_Rot) + Z + (Z * sfactor) + DZ;
        };
        GtMath.XYZ_to_Lat = function (X, Y, Z, a, b) {
            // Convert XYZ to Latitude (PHI) in Dec Degrees.
            // Input: - _
            // XYZ cartesian coords (X,Y,Z) and ellipsoid axis dimensions (a & b), all in meters.
            // THIS FUNCTION REQUIRES THE "Iterate_XYZ_to_Lat" FUNCTION
            // THIS FUNCTION IS CALLED BY THE "XYZ_to_H" FUNCTION
            var RootXYSqr = Math.sqrt(Math.pow(X, 2) + Math.pow(Y, 2));
            var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
            var PHI1 = Math.atan2(Z, (RootXYSqr * (1 - e2)));
            var PHI = GtMath.Iterate_XYZ_to_Lat(a, e2, PHI1, Z, RootXYSqr);
            var Pi = 3.14159265358979;
            return PHI * (180 / Pi);
        };
        GtMath.Iterate_XYZ_to_Lat = function (a, e2, PHI1, Z, RootXYSqr) {
            // Iteratively computes Latitude (PHI).
            // Input: - _
            //    ellipsoid semi major axis (a) in meters; _
            //    eta squared (e2); _
            //    estimated value for latitude (PHI1) in radians; _
            //    cartesian Z coordinate (Z) in meters; _
            // RootXYSqr computed from X & Y in meters.
            // THIS FUNCTION IS CALLED BY THE "XYZ_to_PHI" FUNCTION
            // THIS FUNCTION IS ALSO USED ON IT'S OWN IN THE _
            // "Projection and Transformation Calculations.xls" SPREADSHEET
            var V = a / (Math.sqrt(1 - (e2 * Math.pow(Math.sin(PHI1), 2))));
            var PHI2 = Math.atan2((Z + (e2 * V * (Math.sin(PHI1)))), RootXYSqr);
            while (Math.abs(PHI1 - PHI2) > 0.000000001) {
                PHI1 = PHI2;
                V = a / (Math.sqrt(1 - (e2 * Math.pow(Math.sin(PHI1), 2))));
                PHI2 = Math.atan2((Z + (e2 * V * (Math.sin(PHI1)))), RootXYSqr);
            }
            return PHI2;
        };
        GtMath.XYZ_to_Long = function (X, Y) {
            // Convert XYZ to Longitude (LAM) in Dec Degrees.
            // Input: - _
            // X and Y cartesian coords in meters.
            var Pi = 3.14159265358979;
            return Math.atan2(Y, X) * (180 / Pi);
        };
        GtMath.Lat_Long_to_East = function (PHI, LAM, a, b, e0, f0, PHI0, LAM0) {
            //Project Latitude and longitude to Transverse Mercator eastings.
            //Input: - _
            //    Latitude (PHI) and Longitude (LAM) in decimal degrees; _
            //    ellipsoid axis dimensions (a & b) in meters; _
            //    eastings of false origin (e0) in meters; _
            //    central meridian scale factor (f0); _
            // latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
            // Convert angle measures to radians
            var Pi = 3.14159265358979;
            var RadPHI = PHI * (Pi / 180);
            var RadLAM = LAM * (Pi / 180);
            var RadPHI0 = PHI0 * (Pi / 180);
            var RadLAM0 = LAM0 * (Pi / 180);
            var af0 = a * f0;
            var bf0 = b * f0;
            var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
            var n = (af0 - bf0) / (af0 + bf0);
            var nu = af0 / (Math.sqrt(1 - (e2 * Math.pow(Math.sin(RadPHI), 2))));
            var rho = (nu * (1 - e2)) / (1 - (e2 * Math.pow(Math.sin(RadPHI), 2)));
            var eta2 = (nu / rho) - 1;
            var p = RadLAM - RadLAM0;
            var IV = nu * (Math.cos(RadPHI));
            var V = (nu / 6) * (Math.pow(Math.cos(RadPHI), 3)) * ((nu / rho) - (Math.pow(Math.tan(RadPHI), 2)));
            var VI = (nu / 120) * (Math.pow(Math.cos(RadPHI), 5)) * (5 - (18 * (Math.pow(Math.tan(RadPHI), 2))) + (Math.pow(Math.tan(RadPHI), 4)) + (14 * eta2) - (58 * (Math.pow(Math.tan(RadPHI), 2)) * eta2));
            return e0 + (p * IV) + (Math.pow(p, 3) * V) + (Math.pow(p, 5) * VI);
        };
        GtMath.Lat_Long_to_North = function (PHI, LAM, a, b, e0, n0, f0, PHI0, LAM0) {
            // Project Latitude and longitude to Transverse Mercator northings
            // Input: - _
            // Latitude (PHI) and Longitude (LAM) in decimal degrees; _
            // ellipsoid axis dimensions (a & b) in meters; _
            // eastings (e0) and northings (n0) of false origin in meters; _
            // central meridian scale factor (f0); _
            // latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
            // REQUIRES THE "Marc" FUNCTION
            // Convert angle measures to radians
            var Pi = 3.14159265358979;
            var RadPHI = PHI * (Pi / 180);
            var RadLAM = LAM * (Pi / 180);
            var RadPHI0 = PHI0 * (Pi / 180);
            var RadLAM0 = LAM0 * (Pi / 180);
            var af0 = a * f0;
            var bf0 = b * f0;
            var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
            var n = (af0 - bf0) / (af0 + bf0);
            var nu = af0 / (Math.sqrt(1 - (e2 * Math.pow(Math.sin(RadPHI), 2))));
            var rho = (nu * (1 - e2)) / (1 - (e2 * Math.pow(Math.sin(RadPHI), 2)));
            var eta2 = (nu / rho) - 1;
            var p = RadLAM - RadLAM0;
            var M = GtMath.Marc(bf0, n, RadPHI0, RadPHI);
            var I = M + n0;
            var II = (nu / 2) * (Math.sin(RadPHI)) * (Math.cos(RadPHI));
            var III = ((nu / 24) * (Math.sin(RadPHI)) * (Math.pow(Math.cos(RadPHI), 3))) * (5 - (Math.pow(Math.tan(RadPHI), 2)) + (9 * eta2));
            var IIIA = ((nu / 720) * (Math.sin(RadPHI)) * (Math.pow(Math.cos(RadPHI), 5))) * (61 - (58 * (Math.pow(Math.tan(RadPHI), 2))) + (Math.pow(Math.tan(RadPHI), 4)));
            return I + (Math.pow(p, 2) * II) + (Math.pow(p, 4) * III) + (Math.pow(p, 6) * IIIA);
        };
        GtMath.Marc = function (bf0, n, PHI0, PHI) {
            //Compute meridional arc.
            //Input: - _
            // ellipsoid semi major axis multiplied by central meridian scale factor (bf0) in meters; _
            // n (computed from a, b and f0); _
            // lat of false origin (PHI0) and initial or final latitude of point (PHI) IN RADIANS.
            //THIS FUNCTION IS CALLED BY THE - _
            // "Lat_Long_to_North" and "InitialLat" FUNCTIONS
            // THIS FUNCTION IS ALSO USED ON IT'S OWN IN THE "Projection and Transformation Calculations.xls" SPREADSHEET
            return bf0 * (((1 + n + ((5 / 4) * Math.pow(n, 2)) + ((5 / 4) * Math.pow(n, 3))) * (PHI - PHI0)) - (((3 * n) + (3 * Math.pow(n, 2)) + ((21 / 8) * Math.pow(n, 3))) * (Math.sin(PHI - PHI0)) * (Math.cos(PHI + PHI0))) + ((((15 / 8) * Math.pow(n, 2)) + ((15 / 8) * Math.pow(n, 3))) * (Math.sin(2 * (PHI - PHI0))) * (Math.cos(2 * (PHI + PHI0)))) - (((35 / 24) * Math.pow(n, 3)) * (Math.sin(3 * (PHI - PHI0))) * (Math.cos(3 * (PHI + PHI0)))));
        };
        return GtMath;
    }());
}
//# sourceMappingURL=GridReference.js.map